import { login } from '@/api/login'
import { getOpenid, setOpenid, removeOpenid } from '@/utils/auth'
import { bindOpenIdToRequest } from '@/utils/request'

const user = {
  state: {
    Openid: getOpenid()
  },

  mutations: {
    SET_OPENID: (state, Openid) => {
      state.Openid = Openid
    }
  },

  actions: {
    // 登录
    Login({ commit }, code , state) {
      return new Promise((resolve, reject) => {
        login(code, state).then(response => {
          const Openid = response.openid
          setOpenid(Openid)
          bindOpenIdToRequest()
          //console.log(Openid)
          commit('SET_OPENID', Openid)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js